import {createSlice} from '@reduxjs/toolkit';
import {isMobile} from "../services/Helpers";

const userSettingsSlice = createSlice({
    name: "userSettings",
    initialState: {
        lang: null,
        dir: 'ltr',
        visitedDesktop: !isMobile,
        scheduleLocation: null,
        hasClient: false,
        scheduleViews: {},
        showScheduleUpgrade: null,
        viewProductUpdates: null,
        viewMarketplaceUpdates: null,
        reportsPreferences: {},
        reportsInitialSettings: {}, // per report
        reportsLocation: {}, // per user + box, null = all locations
        sidebarCollapsed: false,
        scheduleAllLocationSelected: false,
        upgradeBarLastClosed: null,
        recurringPaymentsFilters: {},
        recurringPaymentsPreferences: {},
        scheduleCoachFilter: null,
        scheduleScales: null
    },
    reducers: {
        setVisitedDesktop: (state) => {
            state.visitedDesktop = true;
        },
        setHasClient: (state) => {
            state.hasClient = true;
        },
        setLang: (state, data) => {
            state.lang = data.payload;
        },
        setDir: (state, data) => {
            state.dir = data.payload;
        },
        setScheduleLocation: (state, data) => {
            state.scheduleLocation = data.payload
        },
        setScheduleViews: (state, data) => {
            state.scheduleViews = data.payload
        },
        setScheduleScales: (state, data) => {
            state.scheduleScales = data.payload
        },
        setShowScheduleUpgarde: (state, data) => {
            state.showScheduleUpgrade = data.payload
        },
        setViewProductUpdates: (state, data) => {
            state.viewProductUpdates = data.payload
        },
        setViewMarketplaceUpdates: (state, data) => {
            state.viewMarketplaceUpdates = data.payload
        },
        setReportsPreferences: (state, data) => {
            console.log("data.payload.preference", data.payload.preference)
            state.reportsPreferences = {...state.reportsPreferences, [data.payload.report]: data.payload.preference}
        },
        setReportsLocation: (state, data) => {
            state.reportsLocation = {...state.reportsLocation, [data.payload.key]: data.payload.locationId}
        },
        setReportsInitialSettings: (state, data) => {
            state.reportsInitialSettings = {...state.reportsInitialSettings, [data.payload.report]: data.payload.settings}
        },
        setRecurringPaymentsFilters: (state, data) => {
            state.recurringPaymentsFilters = {...state.recurringPaymentsFilters, ...data.payload};

        },
        setScheduleAllLocationSelected: (state, data) => {
            state.scheduleAllLocationSelected = data.payload
        },
        setSidebarCollapsed: (state, data) => {
            state.sidebarCollapsed = data.payload;
        },
        setUpgradeBarLastClosed: (state, data) => {
            state.upgradeBarLastClosed = data.payload;
        },
        setScheduleCoachFilter: (state, data) => {
            state.scheduleCoachFilter = data.payload;
        },
        clearAll: (state) => {
            state.visitedDesktop = !isMobile
            state.scheduleLocation = null
            state.hasClient = false
            state.viewProductUpdates = null
            state.viewMarketplaceUpdates = null
            state.scheduleAllLocationSelected = false
            state.scheduleCoachFilter = null
        },
        clearOnBoxSwitch: (state) => {
            state.scheduleAllLocationSelected = false
            state.scheduleCoachFilter = null
        },
        setRecurringPaymentsPreferences: (state, data) => {
            state.recurringPaymentsPreferences = {...state.recurringPaymentsPreferences, ...data.payload.preference}
        },
        clearRecurringOnBoxSwitch: (state) => {
            state.recurringPaymentsFilters = {}
            state.recurringPaymentsPreferences = {}
            state.error = null
        },
        setFinancePreferences: (state, data) => {
            state.financePreferences = {...state.financePreferences, ...data.payload.preference}
        },
        setFinanceAccountantEmail: (state, data) => {
            state.financeAccountantEmail = data.payload
        },
        setSendConfirmationLinkMessage: (state, data) => {
            state.sendConfirmationLinkMessage = data.payload
        }
    },

});

export const { setLang, setDir, setVisitedDesktop, setScheduleLocation, setHasClient, clearAll, setScheduleViews, setShowScheduleUpgarde, setViewProductUpdates, setViewMarketplaceUpdates, setSidebarCollapsed, setScheduleAllLocationSelected, clearOnBoxSwitch, setReportsPreferences, setReportsInitialSettings, setReportsLocation, setUpgradeBarLastClosed, setRecurringPaymentsFilters, setRecurringPaymentsPreferences, clearRecurringOnBoxSwitch, setScheduleCoachFilter, setFinancePreferences, setFinanceAccountantEmail, setSendConfirmationLinkMessage, setScheduleScales} = userSettingsSlice.actions;

export default userSettingsSlice.reducer;